import { connect } from 'react-redux';

import { StoreState } from '../../../../../reducers';
import PdfSettingsPanel from '../../../../../components/Editor/EditPanel/SettingsPanel/PdfSettingsPanel';
import { getClientAndResourceIds } from '../../../utils/helpers';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: { settings: { pdfSettings, pdfImportingStatus } },
	} = state;
	const { tempGId: publicationId } = getClientAndResourceIds();

	return {
		...pdfSettings,
		publicationId,
		pdfImportingStatus,
	};
};

export default connect(mapStateToProps)(PdfSettingsPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SettingsPanel/PdfSettingsPanel/index.tsx